import {useActions, useGetters, useMutators, useState} from './_map.js';
export default {
    namespaced: true,
    state: {
        ...useState(),
    },
    getters: {
        ...useGetters(),
    },
    mutations: {
        ...useMutators(),
    },
    actions: {
        ...useActions(),
    },
}
